export default __webpack_public_path__ + "static/media/s663-5.fa0493dc.png";